export enum UserOnboardingStepKey {
  AddBankAccount = 'AddBankAccount',
  AssignMoney = 'AssignMoney',
  CreateTarget = 'CreateTarget',
}

export enum TransactionType {
  Inflow = 'Inflow',
  Outflow = 'Outflow',
  Internal = 'Internal',
}

export enum TransactionTemplateUsageStatus {
  Accepted = 'Accepted',
  Rejected = 'Rejected',
}

export enum TransactionStatus {
  Draft = 'Draft',
  Regular = 'Regular',
}

export enum TimeInterval {
  Once = 'Once',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly',
}

export enum TargetType {
  NeededForSpendingMonthly = 'NeededForSpendingMonthly',
  NeededForSpendingByDate = 'NeededForSpendingByDate',
  SavingsBuilder = 'SavingsBuilder',
  SavingsBuilderMonthly = 'SavingsBuilderMonthly',
  DebtPayment = 'DebtPayment',
}

export enum SynchronizationResult {
  Success = 'Success',
  Failed = 'Failed',
}

export enum SurveyAction {
  Completed = 'Completed',
  Skipped = 'Skipped',
}

export enum SubscriptionVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export enum SubscriptionProvider {
  Stripe = 'Stripe',
  RevenueCat = 'RevenueCat',
}

export enum SubscriptionPlanType {
  Trial = 'Trial',
  Basic = 'Basic',
  Premium = 'Premium',
  Max = 'Max',
}

export enum StripeConsentAction {
  Accepted = 'Accepted',
  Rejected = 'Rejected',
}

export enum Role {
  Owner = 'Owner',
  Guest = 'Guest',
}

export enum RepeatPeriod {
  Year = 'Year',
  Month = 'Month',
}

export enum RenameRuleOperator {
  Is = 'Is',
  Contains = 'Contains',
}

export enum OperationType {
  Transaction = 'Transaction',
  Transfer = 'Transfer',
  Reconcile = 'Reconcile',
}

export enum NotificationTemplate {
  Welcome = 'Welcome',
  SubscriptionExpiresSoon = 'SubscriptionExpiresSoon',
  TransactionsSynchronized = 'TransactionsSynchronized',
}

export enum LoanPaymentType {
  Decreasing = 'Decreasing',
  Constant = 'Constant',
}

export enum LoanActivityType {
  Payment = 'Payment',
  InterestPaid = 'InterestPaid',
  InterestRateChange = 'InterestRateChange',
  Reconcile = 'Reconcile',
  TargetDateChange = 'TargetDateChange',
  PaymentTypeChange = 'PaymentTypeChange',
  PrincipalChange = 'PrincipalChange',
  PaymentDayChange = 'PaymentDayChange',
  SkipPayments = 'SkipPayments',
  SkippedPayment = 'SkippedPayment',
  PaymentWithInterest = 'PaymentWithInterest',
}

export enum Language {
  PL = 'PL',
  EN = 'EN',
  DE = 'DE',
}

export enum JobStepStatus {
  NotStarted = 'NotStarted',
  Pending = 'Pending',
  InProgress = 'InProgress',
  Success = 'Success',
  Failure = 'Failure',
}

export enum InterestCalculationMethod {
  Daily = 'Daily',
  Monthly = 'Monthly',
}

export enum Feature {
  BankIntegration = 'BankIntegration',
  BankIntegrationSyncOnDemand = 'BankIntegrationSyncOnDemand',
}

export enum ExpenseType {
  Housing = 'Housing',
  Food = 'Food',
  Transport = 'Transport',
  Self = 'Self',
  Fun = 'Fun',
  Savings = 'Savings',
  Undefined = 'Undefined',
}

export enum DeviceType {
  Mobile = 'Mobile',
  Desktop = 'Desktop',
}

export enum DayOfWeek {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
}

export enum Currency {
  PLN = 'PLN',
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  CAD = 'CAD',
  AUD = 'AUD',
  CZK = 'CZK',
  CHF = 'CHF',
  DKK = 'DKK',
  SEK = 'SEK',
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ANG = 'ANG',
  AOA = 'AOA',
  ARS = 'ARS',
  AWG = 'AWG',
  AZN = 'AZN',
  BAM = 'BAM',
  BBD = 'BBD',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BMD = 'BMD',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BSD = 'BSD',
  BTN = 'BTN',
  BWP = 'BWP',
  BYN = 'BYN',
  BZD = 'BZD',
  CDF = 'CDF',
  CLF = 'CLF',
  CLP = 'CLP',
  COP = 'COP',
  CRC = 'CRC',
  CUC = 'CUC',
  CUP = 'CUP',
  CVE = 'CVE',
  DJF = 'DJF',
  DOP = 'DOP',
  DZD = 'DZD',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  FJD = 'FJD',
  FKP = 'FKP',
  GEL = 'GEL',
  GHS = 'GHS',
  GIP = 'GIP',
  GMD = 'GMD',
  GNF = 'GNF',
  GTQ = 'GTQ',
  GYD = 'GYD',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HTG = 'HTG',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KGS = 'KGS',
  KHR = 'KHR',
  KMF = 'KMF',
  KPW = 'KPW',
  KRW = 'KRW',
  KWD = 'KWD',
  KYD = 'KYD',
  KZT = 'KZT',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LRD = 'LRD',
  LSL = 'LSL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MNT = 'MNT',
  MOP = 'MOP',
  MRU = 'MRU',
  MUR = 'MUR',
  MVR = 'MVR',
  MWK = 'MWK',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PGK = 'PGK',
  PHP = 'PHP',
  PKR = 'PKR',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  CNY = 'CNY',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SBD = 'SBD',
  SCR = 'SCR',
  SDG = 'SDG',
  SGD = 'SGD',
  SHP = 'SHP',
  SLL = 'SLL',
  SLE = 'SLE',
  SOS = 'SOS',
  SRD = 'SRD',
  SSP = 'SSP',
  STN = 'STN',
  SVC = 'SVC',
  SYP = 'SYP',
  SZL = 'SZL',
  THB = 'THB',
  TJS = 'TJS',
  TMT = 'TMT',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  UYU = 'UYU',
  UYW = 'UYW',
  UZS = 'UZS',
  VED = 'VED',
  VES = 'VES',
  VND = 'VND',
  VUV = 'VUV',
  WST = 'WST',
  XCD = 'XCD',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMW = 'ZMW',
  ZWL = 'ZWL',
}

export enum CategoryType {
  Income = 'Income',
  Expense = 'Expense',
  Saving = 'Saving',
}

export enum CategoryPurpose {
  UserDefined = 'UserDefined',
  Uncategorized = 'Uncategorized',
}

export enum BankConnectionOnboardingStep {
  MonitorInitialRequisition = 'MonitorInitialRequisition',
  BankAccountSynchronization = 'BankAccountSynchronization',
  TransactionSynchronization = 'TransactionSynchronization',
}

export enum BankAccountStatus {
  Active = 'Active',
  Closed = 'Closed',
}

export interface AddTransactionRequest {
  splits?: BaseTransactionCategorySplitDto[] | null
  budgetId: string
  transactionId: string
  bankAccountId?: string | null
  type: TransactionType
  /** @format date */
  date: Date
  /** @format double */
  value: number
  currency: string
  note: string
  transactionSideName: string
  transactionSideId?: string | null
}

export interface AddTransferRequest {
  budgetId: string
  transactionId: string
  bankAccountId?: string | null
  targetBankAccountId?: string | null
  /** @format date */
  date: Date
  /** @format double */
  value: number
  currency: string
  note: string
}

export interface AssignmentRecordDto {
  id: string
  budgetId: string
  periodKey: string
  fromCategoryId?: string | null
  toCategoryId?: string | null
  /** @format double */
  value: number
  /** @format date */
  date: Date
}

export interface AuthRequest {
  secret: string
  email: string
  reasons: string
}

export interface AutoAssignItemDto {
  categoryId: string
  /** @format double */
  value: number
}

export interface AutoAssignRequest {
  periodKey: string
  budgetId: string
  items?: AutoAssignItemDto[] | null
}

export interface BankAccountDto {
  id: string
  name: string
  status: BankAccountStatus
  /** @format int32 */
  order: number
  bankConnectionAccountId: string
  bankConnectionId?: string | null
  isLinked: boolean
  synchronizationStatus?: SynchronizationStatusDto | null
}

export interface BankConnectionAccountDto {
  id: string
  name: string
  iban: string
  /** @format double */
  balance: number
  currency: string
}

export interface BankConnectionDto {
  id: string
  institutionId: string
  displayName?: string | null
  status: string
  isReady: boolean
  accounts?: BankConnectionAccountDto[] | null
}

export interface BankConnectionOnboardingLogDto {
  bankConnectionId: string
  steps?: BankConnectionOnboardingStepLogDto[] | null
  isInProgress: boolean
}

export interface BankConnectionOnboardingStepLogDto {
  step: BankConnectionOnboardingStep
  status: JobStepStatus
  timestamp?: JobStepTimestamp | null
}

export interface BankConnectionUsageDto {
  /** @format int32 */
  used: number
  /** @format int32 */
  limit: number
  canAddMore: boolean
  subscriptionPlanType: string
  /** @format int32 */
  activeConnectionsAtMonthStart: number
  /** @format int32 */
  newConnectionsDuringMonth: number
}

export interface BankInstitution {
  id: string
  name: string
  bic: string
  logo: string
  countries: string[]
}

export interface BaseTransactionCategorySplitDto {
  id: string
  categoryId: string
  categoryName: string
  categoryType: string
  /** @format double */
  value: number
  currency: string
}

export interface BudgetCollaborationDto {
  id: string
  collaboratorEmail: string
}

export interface BudgetDto {
  id: string
  name: string
  role: Role
  isReadOnly: boolean
  isShared: boolean
  currency: Currency
  isEnvelope: boolean
}

export interface BudgetIdResult {
  isFailure: boolean
  isSuccess: boolean
  error: string
  value: string
}

export interface BudgetUserDto {
  userId: string
  userName: string
  userEmail: string
  isCurrentUser: boolean
}

export interface CategoryDto {
  id: string
  categoryGroupId: string
  name: string
  /** @format int32 */
  order: number
  type: CategoryType
  isFund: boolean
  isHidden: boolean
  isEnvelope: boolean
  note: string
  purpose: CategoryPurpose
  isUserManaged: boolean
}

export interface CategoryGroupDto {
  id: string
  name: string
  budgetId: string
  expenseType: ExpenseType
  type: CategoryType
  /** @format int32 */
  order: number
  isSystemManaged: boolean
}

export interface ChangeBankAccountNameRequest {
  id: string
  name: string
}

export interface ChangeBankAccountOrderRequest {
  /** @format int32 */
  order: number
  bankAccountId: string
}

export interface ChangeBankConnectionDisplayNameRequest {
  id: string
  displayName: string
}

export interface ChangeCategoryOrderRequest {
  /** @format int32 */
  order: number
  newCategoryGroupId: string
}

export interface ChangeSubscriptionTypeRequest {
  subscriptionPlanType: SubscriptionPlanType
}

export interface CloseBankAccountRequest {
  bankAccountId: string
  targetBankAccountId?: string | null
  /** @format double */
  remainingBalance?: number | null
}

export interface CompleteBankConnectionRequest {
  code?: string | null
  state: string
  error?: string | null
  budgetId: string
}

export interface CompleteBankConnectionResponse {
  budgetId: string
  bankConnectionId: string
  isReauthorization: boolean
}

export interface ConvertTransactionToTransferRequest {
  transactionId: string
  targetBankAccountId: string
  note: string
}

export interface CopyPlansRequest {
  budgetId: string
  sourcePeriodKey: string
  targetPeriodKey: string
}

export interface CreateBankAccountRequest {
  id: string
  budgetId: string
  name: string
  /** @format date */
  date: Date
  /** @format double */
  balance: number
}

export interface CreateBudgetCollaborationRequest {
  budgetId: string
  collaboratorEmail: string
}

export interface CreateBudgetRequest {
  name: string
  currency: Currency
}

export interface CreateCategoryGroupRequest {
  id: string
  budgetId: string
  type: CategoryType
  name: string
}

export interface CreateCategoryRequest {
  id: string
  categoryGroupId: string
  name: string
}

export interface CreateLoanRequest {
  id: string
  budgetId: string
  name: string
  /** @format date */
  targetDate: Date
  paymentType: LoanPaymentType
  /** @format double */
  rate: number
  /** @format double */
  principal: number
  /** @format int32 */
  paymentDay: number
  interestCalculationMethod: InterestCalculationMethod
}

export interface CreateOrUpdatePlanRequest {
  categoryId: string
  budgetId: string
  periodKey: string
  /** @format double */
  value: number
  currency: string
}

export interface CreateTransactionSideRequest {
  id: string
  budgetId: string
  name: string
  isAutoCategorizeEnabled: boolean
  defaultCategoryId?: string | null
  renameRules?: RenameRuleDto[] | null
}

export interface CreateTransactionTemplateRequest {
  transactionTemplateId: string
  budgetId: string
  bankAccountId?: string | null
  splits?: BaseTransactionCategorySplitDto[] | null
  expensePlans?: BaseTransactionCategorySplitDto[] | null
  /** @format date */
  startDate: Date
  /** @format double */
  value: number
  currency: string
  note: string
  interval: TimeInterval
  type: TransactionType
  transactionSideId?: string | null
}

export interface DeleteCategoryGroupRequest {
  id: string
  targetCategoryId: string
}

export interface DeleteCategoryRequest {
  id: string
  targetCategoryId: string
}

export interface DeleteTransactionSidesRequest {
  sourceIds?: string[] | null
  targetTransactionSideId?: string | null
}

export interface ExportBudgetRequest {
  periodKeyFrom: string
  periodKeyTo: string
}

export interface FeatureFlagConfiguration {
  bankIntegrationEnabled: boolean
  transactionSidesEnabled: boolean
  syncOnDemandEnabled: boolean
}

export interface FilterDto {
  id?: string | null
  name: string
  categories?: string[] | null
  bankAccounts?: string[] | null
}

export interface ImportResultDto {
  /** @format date */
  dateTime: Date
  /** @format double */
  amount: number
  description: string
  transactionSideName?: string | null
  categoryId: string
  transactionSideId?: string | null
}

export interface InitiateBankConnectionRequest {
  institutionId: string
  countryCode: string
}

export interface InitiateBankConnectionResponse {
  authorizationUrl: string
  bankConnectionId: string
  skipConsentWidget: boolean
}

export interface JobStepTimestamp {
  /** @format date */
  pendingDate: Date
  /** @format date */
  inProgressDate: Date
  /** @format date */
  successOrFailureDate: Date
  message: string
}

export interface LinkBankConnectionAccountRequest {
  bankConnectionAccountId: string
  bankAccountId: string
}

export interface LinkCategoryRequest {
  loanId: string
  categoryId: string
  periodKey: string
}

export interface LoanActivityDto {
  id: string
  loanId: string
  type: LoanActivityType
  value: string
  /** @format date */
  date: Date
  isInitial: boolean
  isGenerated: boolean
}

export interface LoanDto {
  id: string
  budgetId: string
  categoryId?: string | null
  name: string
  usesNewAlgorithm: boolean
  interestCalculationMethod: InterestCalculationMethod
}

export interface MergeTransactionSidesRequest {
  newId: string
  budgetId: string
  name: string
  isAutoCategorizeEnabled: boolean
  defaultCategoryId?: string | null
  sourceIds?: string[] | null
  renameRules?: RenameRuleDto[] | null
}

export interface MovePlanRequest {
  categoryId: string
  targetCategoryId: string
  budgetId: string
  periodKey: string
  /** @format double */
  value: number
}

export interface NotificationDto {
  /** @format uuid */
  id: string
  /** @format uuid */
  userId: string
  data?: any
  /** @format date */
  createdOn: Date
  seen: boolean
  template: NotificationTemplate
}

export interface OnboardingDto {
  firstStepCompleted: boolean
  secondStepCompleted: boolean
  thirdStepCompleted: boolean
  onboardingCompleted: boolean
}

export interface OnboardingScheduledEventDto {
  id: string
  eventName: string
  jsonData: string
}

export interface PatchTransactionRequest {
  transactionId: string
  categoryId: string
  note: string
  isVerified: boolean
}

export interface PatchTransactionsBulkRequest {
  budgetId: string
  items?: PatchTransactionsBulkRequestItem[] | null
}

export interface PatchTransactionsBulkRequestItem {
  transactionId: string
  categoryId: string
  note: string
}

export interface PlanDto {
  categoryId: string
  /** @format double */
  value: number
  periodKey: string
}

export interface PlanFeatureDto {
  feature: Feature
  /** @format int32 */
  limitValue?: number | null
}

export interface PromoCodeDto {
  promoCodeId: string
  name: string
  /** @format double */
  value: number
  isAvailable: boolean
}

export interface ReconcileBankAccountReqeust {
  transactionId: string
  id: string
  /** @format double */
  value: number
  /** @format date */
  date: Date
}

export interface RecordLoanActivityRequest {
  id: string
  loanId: string
  bankAccountId?: string | null
  value?: any
  type: LoanActivityType
  /** @format date */
  date: Date
}

export interface RecordUserVisitRequest {
  clientId: string
  sessionId: string
  sessionNumber: string
}

export interface ReferralCodeDto {
  code: string
  /** @format int32 */
  paidUsageCount: number
  /** @format int32 */
  usageCount: number
}

export interface RejectTransactionTemplateRequest {
  transactionTemplateId: string
  /** @format date */
  templateTransactionDate: Date
}

export interface RenameRuleDto {
  id: string
  operator: RenameRuleOperator
  value: string
}

export interface SaveAnalyticsDataRequest {
  acquisitionData: string
  device: DeviceType
}

export interface SaveCategoryNoteRequest {
  id: string
  note: string
}

export interface SaveNPSSurveyResponseRequest {
  data: string
  /** @format int32 */
  score: number
  isMobile: boolean
  surveyAction: SurveyAction
}

export interface ScheduledLoanPaymentDto {
  loanId: string
  /** @format date */
  dateTime: Date
  /** @format double */
  principal: number
  /** @format double */
  interest: number
  hasCoveringPayment: boolean
}

export interface SetTargetRequest {
  categoryId: string
  startPeriodKey: string
  endPeriodKey: string
  /** @format double */
  value?: number | null
  /** @format int32 */
  dueDay?: number | null
  /** @format date */
  dueDate?: Date
  repeat: boolean
  repeatPeriod?: RepeatPeriod | null
  /** @format int32 */
  repeatFrequency?: number | null
  type: TargetType
}

export interface SetupBankAccountsFromConnectionRequest {
  bankConnectionAccountIds?: string[] | null
  budgetId: string
}

export interface SpecialOfferDto {
  id: string
  /** @format date */
  endDate: Date
  isOfferActive: boolean
  seen: boolean
  /** @format double */
  value: number
}

export interface SubmitStripeConsentRequest {
  content: string
  action: StripeConsentAction
  /** @format date */
  consentedAt: Date
}

export interface SubscriptionDto {
  /** @format date */
  expiresAt: Date
  type: SubscriptionPlanType
  isExpired: boolean
  version: SubscriptionVersion
  provider: SubscriptionProvider
  needsNewSubscription: boolean
}

export interface SubscriptionPlanDto {
  type: SubscriptionPlanType
  name: string
  isActive: boolean
  features?: PlanFeatureDto[] | null
}

export interface SubscriptionPlanTrialDto {
  targetPlan: SubscriptionPlanType
  /** @format int32 */
  durationDays: number
  features?: PlanFeatureDto[] | null
}

export interface SurveyDto {
  /** @format date */
  dateTime?: Date
  surveyAction?: SurveyAction | null
}

export interface SynchronizationStatusDto {
  /** @format date */
  lastSyncStartDate?: Date
  /** @format date */
  lastSyncEndDate?: Date
  /** @format date */
  lastSuccessfulSyncDate?: Date
  /** @format date */
  nextSyncDate?: Date
  lastSynchronizationResult?: SynchronizationResult | null
}

export interface SynchronizeBankAccountTransactionsRequest {
  bankAccountId: string
  bankConnectionId: string
}

export interface TargetDto {
  id: string
  categoryId: string
  /** @format double */
  value?: number | null
  startPeriodKey: string
  endPeriodKey: string
  /** @format int32 */
  dueDay?: number | null
  /** @format date */
  dueDate?: Date
  repeat: boolean
  repeatPeriod?: RepeatPeriod | null
  /** @format int32 */
  repeatFrequency?: number | null
  type: TargetType
}

export interface TransactionDto {
  id: string
  /** @format double */
  value: number
  currency: string
  bankAccountId?: string | null
  targetBankAccountId?: string | null
  budgetId: string
  note: string
  periodKey: string
  /** @format date */
  date: Date
  paidBy: string
  paidById: string
  status?: TransactionStatus | null
  operationType: OperationType
  transactionType: TransactionType
  isLinkedToLoanActivity: boolean
  isVerified: boolean
  transactionSideId?: string | null
  transactionSideName?: string | null
  isSynchronizedFromBank: boolean
}

export interface TransactionSideDto {
  id: string
  budgetId: string
  name: string
  isAutoCategorizeEnabled: boolean
  defaultCategoryId?: string | null
  renameRules?: TransactionSideRenameRuleDto[] | null
  /** @format int32 */
  transactionsCount: number
  /** @format int32 */
  templatesCount: number
}

export interface TransactionSideRenameRuleDto {
  id: string
  operator: RenameRuleOperator
  value: string
}

export interface TransactionSplitDto {
  id: string
  categoryId: string
  categoryName: string
  categoryType: string
  /** @format double */
  value: number
  currency: string
  transactionId: string
  bankAccountId?: string | null
  budgetId: string
  note: string
  paidBy: string
  paidById: string
  periodKey: string
  /** @format date */
  date: Date
  type: TransactionType
  transactionTemplateId: string
  status?: TransactionStatus | null
}

export interface TransactionTemplateDto {
  id: string
  /** @format double */
  value: number
  currency: string
  budgetId: string
  bankAccountId?: string | null
  note: string
  paidBy: string
  paidById: string
  type: TransactionType
  interval: TimeInterval
  /** @format date */
  startDate: Date
  transactionSideId?: string | null
  usages?: TransactionTemplateUsageDto[] | null
}

export interface TransactionTemplateSplitDto {
  id: string
  categoryId: string
  categoryName: string
  categoryType: string
  /** @format double */
  value: number
  currency: string
  transactionTemplateId: string
}

export interface TransactionTemplateUsageDto {
  id: string
  transactionTemplateId: string
  /** @format date */
  templateTransactionDate: Date
  status: TransactionTemplateUsageStatus
}

export interface UpdateBudgetRequest {
  id: string
  currency: Currency
  name: string
}

export interface UpdateCategoryGroupRequest {
  id: string
  name: string
  /** @format int32 */
  order: number
}

export interface UpdateCategoryRequest {
  id: string
  name: string
}

export interface UpdateLoanActivityRequest {
  loanId: string
  id: string
  value?: any
  /** @format date */
  date: Date
  bankAccountId?: string | null
}

export interface UpdateLoanRequest {
  loanId: string
  name: string
  interestCalculationMethod: InterestCalculationMethod
}

export interface UpdateProfileRequest {
  /** @format uuid */
  userId: string
  name: string
  secret: string
}

export interface UpdateReconcileBankAccountReqeust {
  transactionId: string
  bankAccountId: string
  /** @format double */
  value: number
  /** @format date */
  date: Date
}

export interface UpdateReminderSettingsRequest {
  reminderDay?: DayOfWeek | null
  /** @format int32 */
  reminderHour?: number | null
  /** @format int32 */
  reminderMinute?: number | null
  isBudgetingReminderActive: boolean
}

export interface UpdateTransactionRequest {
  transactionId: string
  bankAccountId: string
  splits?: BaseTransactionCategorySplitDto[] | null
  budgetId: string
  /** @format date */
  date: Date
  /** @format double */
  value: number
  currency: string
  note: string
  type: TransactionType
  transactionSideId?: string | null
}

export interface UpdateTransactionSideRequest {
  name: string
  isAutoCategorizeEnabled: boolean
  defaultCategoryId?: string | null
  renameRules?: RenameRuleDto[] | null
}

export interface UpdateTransactionTemplateRequest {
  transactionTemplateId: string
  bankAccountId?: string | null
  splits?: BaseTransactionCategorySplitDto[] | null
  expensePlans?: BaseTransactionCategorySplitDto[] | null
  /** @format date */
  startDate: Date
  /** @format double */
  value: number
  currency: string
  note: string
  interval: TimeInterval
  type: TransactionType
  transactionSideId?: string | null
}

export interface UpdateTransferRequest {
  transactionId: string
  budgetId: string
  /** @format date */
  date: Date
  /** @format double */
  value: number
  currency: string
  note: string
}

export interface UpsertFilterRequest {
  id: string
  budgetId: string
  name: string
  categories?: string[] | null
  bankAccounts?: string[] | null
}

export interface UseTransactionTemplateRequest {
  transactionId: string
  transactionTemplateId: string
  bankAccountId: string
  /** @format date */
  date: Date
  /** @format date */
  templateTransactionDate: Date
  /** @format double */
  value: number
  currency: string
  note: string
  splits?: BaseTransactionCategorySplitDto[] | null
  expensePlans?: BaseTransactionCategorySplitDto[] | null
  type: TransactionType
  transactionSideId: string
}

export interface UserDto {
  id: string
  email: string
  name: string
  /** @format date */
  createdAt?: Date
  finishedOnboarding: boolean
  isEmailConfirmed: boolean
  /** @format int32 */
  seenCount: number
  isDisabled: boolean
  referral: string
}

export interface UserOnboardingDto {
  steps?: UserOnboardingStepDto[] | null
  isCompleted: boolean
  /** @format date */
  completedAt: Date
  isFinished: boolean
}

export interface UserOnboardingStepDto {
  stepKey: UserOnboardingStepKey
  /** @format int32 */
  order: number
  isCompleted: boolean
  /** @format date */
  completedAt: Date
}

export interface UserSettingsDto {
  isBudgetingReminderActive: boolean
  defaultBudgetId: string
  defaultBankAccountId: string
  reminderDay?: DayOfWeek | null
  /** @format int32 */
  reminderHour: number
  /** @format int32 */
  reminderMinute: number
  lastSeenPeriodKey?: string | null
  language: Language
}

export interface UserSubscriptionPlanInfoDto {
  currentPlan?: SubscriptionPlanDto | null
  activeTrial?: UserSubscriptionPlanTrialDto | null
  eligibleTrial?: SubscriptionPlanTrialDto | null
  effectiveFeatures?: PlanFeatureDto[] | null
}

export interface UserSubscriptionPlanTrialDto {
  /** @format uuid */
  id: string
  trialPlan: SubscriptionPlanType
  /** @format date */
  startedAt: Date
  /** @format date */
  expiresAt: Date
  features?: PlanFeatureDto[] | null
}
